import React, { Component } from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Heading from '@react/react-spectrum/Heading';
import { CONTACT_HELPDESK } from '../../config/constants';
import Button from '@react/react-spectrum/Button';
import { Translate } from 'react-redux-i18n';

class Finish extends Component {

    render(){
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                        <Heading className = "textBold dark padding-5" variant="pageTitle">Thank you</Heading>
                        <GridRow className = "padding-3 font">
                            <GridColumn>
                                <span>Thank you for submitting your specialization application. You will receive an email about the status of your application. 
                                If you need assistance, please contact the Adobe Partner Connection Help Desk.</span>
                            </GridColumn>
                        </GridRow>
                        <GridRow>
                            <GridColumn className = "padding-3">
                                <Button variant="primary" onClick={()=>{
                                    window.open(CONTACT_HELPDESK,"_blank");
                                }
                                }>Contact Helpdesk</Button>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}

export default Finish;